/**
 * useAssetFallback —— 单资源加载失败的显式降级状态（F07 Asset-level）。
 *
 * 三级 Fallback Notice 的 Asset 层：单个图片 / 视频 URL 加载失败时，
 * UI 切换到占位形态（默认图 / 封面 + 提示），同时**必须**保留
 * `console.error` 可观测信号（AGENTS §六 Debug-First，不静默吞错）。
 *
 * 本 composable 只管"是否失败 + 失败时打日志"两件事，UI 切换由消费方
 * 据 `failed` 自行渲染（图片换 src、视频隐藏 controls 等），保持
 * 表现层与状态层分离。`context` 是日志定位串（如 section id + 资源
 * 序号），便于在多资源列表中精准定位是哪一张图挂了。
 */
import { ref, type Ref } from 'vue';

export interface AssetFallback {
  /** 是否已失败；消费方据此切换占位 UI（ref，模板自动解包，script 用 .value）。 */
  readonly failed: Ref<boolean>;
  /** 绑定到 `<img @error>` / `<video @error>`：置 failed + console.error。 */
  handleError(event: Event): void;
}

export function useAssetFallback(context: string): AssetFallback {
  const failed = ref(false);

  function handleError(event: Event): void {
    failed.value = true;
    const target = event.currentTarget;
    // eslint-disable-next-line no-console
    console.error(`[AssetFallback] ${context}`, target);
  }

  return { failed, handleError };
}
